import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_Img01 from '../images/balloonsodyssey/images-04.png';


export default function BalloonsOdyssey_Skin03() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: Wizard skin"
        description="Wizard skin is obtainable via store on Balloons Odyssey."
        images={[BalloonsOdyssey_Img01]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}